import { z } from 'zod'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

import { ImplementationContract } from '../../../cross-chain-deployment/ImplementationContract'

export const ImplementationContractSchema = z.string()

type ImplementationContractReportText = z.infer<
  typeof ImplementationContractSchema
>

export function mapDomainToReportText(
  postDeploymentModule: ImplementationContract
): ImplementationContractReportText {
  return postDeploymentModule.getValue().getValue()
}

export function mapReportTextToDomain(
  reportText: ImplementationContractReportText
): ImplementationContract {
  return ImplementationContract.create({
    implementationContractValue: HexNumber.create({
      hexNumberValue: reportText,
    }),
  })
}
